module.exports = __webpack_public_path__ + "media/images/applications/cheque-6b8fa57cceaf258b9b4255d5f8e0a8f7.svg";